import React from 'react';
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import EditIcon from 'assets/edit_outlined.svg?react';

interface EditButtonProps {
  onEdit?: () => void;
}

const EditButton: React.FC<EditButtonProps> = ({ onEdit }) => {
  return (
    <Button
      type={ButtonType.outline}
      onClick={onEdit}
      icon={
        <span className="edit-icon-wrapper">
          <EditIcon style={{ width: '18px', height: '18px' }} />
        </span>
      }
      data-testid="primary-action-button"
      style={{
        width: '71px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px'
      }}
    >
      Edit
    </Button>
  );
};

export default EditButton;
